import { selector } from 'lib/selectors';
import { aggregationsSelector } from 'domain/documents/documentSelector';
import type { SearchAggregations, SearchSubtypeChip } from 'domain/documents/schemas';

const EMPTY: SearchSubtypeChip[] = [];

// Present sub-type facet for the active workspace category, from the search_new `aggregations`
// block (backend-driven; incl. the "All" default chip with id:null and the "Unclassified" entry).
// Rendered as Inbox chips. Empty until aggregations resolve.
export const workspaceSubtypesSelector = selector<unknown, SearchSubtypeChip[]>(
  aggregationsSelector,
  (aggregations: SearchAggregations | null): SearchSubtypeChip[] =>
    aggregations ? aggregations.subtypes : EMPTY,
);
